/*  global jQuery, $  */
jQuery(document).ready(function () {
  // 手機側邊選單
  $('nav#menu').mmenu({
    drag: true,
    pageScroll: {
      scroll: true,
      update: true
    },
    'extensions': [
      'theme-dark',
      'fx-menu-fade',
      'fx-listitems-slide'
    ]
  }, {
    classNames: {
      fixedElements: {
        fixed: 'fix',
        sticky: 'sticky-top'
      }
    }
  })
  // Header Sticker
  // $('#pageHeader').sticky({topSpacing: 0})
  // $('#pageHeader').on('sticky-end', function () { $(this).parent('.sticky-wrapper').css({height: 'auto'}) }) // sticky 補丁

  // Header 捲動
  $(window).bind('scroll', function () {
    var top = 100;
    if ($(window).scrollTop() > top) {
      $('#pageHeader').addClass('is-sticky fixed animated fadeInDown')
    } else {
      $('#pageHeader').removeClass('is-sticky fixed animated fadeInDown')
    }
  })
  // 滾動視差
  // $('.parallaxie').parallaxie();


  // $().UItoTop({ easingType: 'easeOutQuart', text: '<i class="icon-up-small"></i>'})
  $('.dropdown-hover').dropdownHover(100)

  $('#heroBanner').slick({
    dots: true,
    infinite: true,
    speed: 300
  })

  $('#recommendationSilder').slick({
    infinite: false
  })

  $('#loginSider').slick({
    dots: true,
    infinite: true,
    speed: 300
  })

  $('.lazy').Lazy()
  $('.slick-slider').mouseover(function (params) {
    var _this = $(this)
    _this.find('.slick-next').addClass("animated bounceInRight")
    _this.find('.slick-prev').addClass("animated bounceInLeft")
  })




});
